import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";

Vue.prototype.$marketplace_consumidor = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      consumidores: [],
      select_consumidores: [],
      pedidos: [],
      loading_pedidos: false,
      itens_pedido: [],
      loading_itens_pedido: false,
      modalSelectStore: false,
      filtros: [],
      filter: {
        nome: "",
        razao_social: "",
        documento: "",
        passaporte: "",
        // cnpj: '',
        status: "",
        tipoPessoa: "",
        dataInicio: "",
        dataFim: "",
      },
      consumidorAddOrEdit: "new",
      marketplace_selecionada: "",
      marketplace_loading: false,
      marketplace_nome: "",
      cadastro: {
        loading: false,
        loading_consumidores: false,
        dados_cadastrais: {
          id: "",
          pessoa: "FISICA",
          foto: { imagem: null, have: false },
          nome: "",
          dt_nascimento: "",
          documento: "",
          passaporte: "",
          email: "",
          celular: "",
          idioma: "",
          status: "",
          cep: "",
          pais: "",
          estado: "",
          cidade: "",
          bairro: "",
          logradouro: "",
          end_numero: "",
          cnpj: "",
          razao_social: "",
          error: {
            nome: [],
            dt_nascimento: [],
            documento: [],
            passaporte: [],
            email: [],
            cnpj: [],
            razao_social: [],
            celular: [],
            idioma: [],
            status: [],
            cep: [],
            pais: [],
            estado: [],
            cidade: [],
            bairro: [],
            logradouro: [],
            end_numero: [],
          },
        },
      },
    };
  },
  methods: {
    /**
     * @description Função para listar todos os consumidores do marketplace
     */
    getAllConsumidores() {
      this.cadastro.loading_consumidores = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_CONSUMIDORES_MARKET)
        .then(response => {
          this.cadastro.loading_consumidores = false;
          this.consumidores = response;
        });
    },

    // ---- DESABILITAR CONSUMIDOR ---- //
    desabilitarConsumidor(idconsumidor) {
      this.$axios
        .put(this.ENDPOINTS.DESABILITAR_CONSUMIDORES_MARKET + idconsumidor)
        .then(() => {
          document.location.reload();
        });
    },
    // ---- HABILITAR CONSUMIDOR ---- //
    habilitarConsumidor(idconsumidor) {
      this.$axios
        .put(this.ENDPOINTS.ALTERAR_CONSUMIDORES_MARKET + idconsumidor, {
          status: "ATIVO",
        })
        .then(() => {
          document.location.reload();
        });
    },

    // ---- ALTERAR CONSUMIDOR ---- //
    alterarConsumidor() {
      this.cadastro.loading = true;
      let dados = {};
      if (this.cadastro.dados_cadastrais.pessoa == "JURIDICA") {
        dados = {
          email: this.cadastro.dados_cadastrais.email,
          senha: "",
          status: this.cadastro.dados_cadastrais.status,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          celular: this.cadastro.dados_cadastrais.celular,
          idioma: this.cadastro.dados_cadastrais.idioma,
          imagem: this.cadastro.dados_cadastrais.foto.imagem,
          isadmin: true,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_numero: this.cadastro.dados_cadastrais.end_numero,

          cnpj: this.cadastro.dados_cadastrais.cnpj,
          passaporte: this.cadastro.dados_cadastrais.passaporte,
          razao_social: this.cadastro.dados_cadastrais.razao_social,
        };
      } else {
        dados = {
          nome: this.cadastro.dados_cadastrais.nome,
          dt_nascimento: this.$config.convertDataEN(
            this.cadastro.dados_cadastrais.dt_nascimento
          ),
          email: this.cadastro.dados_cadastrais.email,
          senha: "",
          status: this.cadastro.dados_cadastrais.status,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          documento: this.cadastro.dados_cadastrais.documento,
          passaporte: this.cadastro.dados_cadastrais.passaporte,
          celular: this.cadastro.dados_cadastrais.celular,
          idioma: this.cadastro.dados_cadastrais.idioma,
          imagem: this.cadastro.dados_cadastrais.foto.imagem,
          isadmin: true,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_numero: this.cadastro.dados_cadastrais.end_numero,
        };
      }

      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_CONSUMIDORES_MARKET +
            this.cadastro.dados_cadastrais.id,
          dados
        )
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditConsumidor", true);
            this.limpaFormularioDeConsumidor();
            router.push({ name: "marketplaceConsumer" });
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- CADASTRAR CONSUMIDOR ---- //
    async cadastrarConsumidor() {
      this.cadastro.loading = true;
      let dados = {};
      if (this.cadastro.dados_cadastrais.pessoa == "JURIDICA") {
        dados = {
          email: this.cadastro.dados_cadastrais.email,
          senha: "",
          status: this.cadastro.dados_cadastrais.status,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          celular: this.cadastro.dados_cadastrais.celular,
          idioma: this.cadastro.dados_cadastrais.idioma,
          imagem: this.cadastro.dados_cadastrais.foto.imagem,

          end_cep: this.cadastro.dados_cadastrais.cep,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_numero: this.cadastro.dados_cadastrais.end_numero,

          cnpj: this.cadastro.dados_cadastrais.cnpj,
          passaporte: this.cadastro.dados_cadastrais.passaporte,
          razao_social: this.cadastro.dados_cadastrais.razao_social,
          captcha: "",
          isadmin: true,
        };
      } else {
        dados = {
          // dados cadastrais
          nome: this.cadastro.dados_cadastrais.nome,
          dt_nascimento: this.$config.convertDataEN(
            this.cadastro.dados_cadastrais.dt_nascimento
          ),
          email: this.cadastro.dados_cadastrais.email,
          senha: "",
          status: this.cadastro.dados_cadastrais.status,
          tipo_pessoa: this.cadastro.dados_cadastrais.pessoa,
          documento: this.cadastro.dados_cadastrais.documento,
          passaporte: this.cadastro.dados_cadastrais.passaporte,
          celular: this.cadastro.dados_cadastrais.celular,
          idioma: this.cadastro.dados_cadastrais.idioma,
          imagem: this.cadastro.dados_cadastrais.foto.imagem,

          // endereço
          end_cep: this.cadastro.dados_cadastrais.cep,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado: this.cadastro.dados_cadastrais.estado,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          end_bairro: this.cadastro.dados_cadastrais.bairro,
          end_logradouro: this.cadastro.dados_cadastrais.logradouro,
          end_numero: this.cadastro.dados_cadastrais.end_numero,
          captcha: "",
          isadmin: true,
        };
      }

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_CONSUMIDORES_MARKET, dados)
        .then(response => {
          if (response) {
            this.limpaFormularioDeConsumidor();
            router.push({ name: "marketplaceConsumer" });
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- FUNÇÃO PARA REDEFINIR A SENHA ---- //
    async trocarSenha() {
      let idusuario = this.$axios.getLocal("oe_user_info").data.idusuario;
      if (this.user.old_password.length == 0) {
        this.$config.alert(
          "Insira sua senha atual!",
          this.$config.dados.errorColor
        );
        this.$usuario.user.error.old_password = "Insira sua senha atual";
        return;
      }
      // if(this.validaSenha(this.cadastro.senha) < 60)
      //     { this.$config.alert(this.$t_('preencha_senha_corret'), this.$config.dados.errorColor); this.$usuario.cadastro.error.senha = this.$t_('preencha_senha_corret'); return }
      if (this.user.senha != this.user.senha2) {
        this.$config.alert(
          "As senhas são incompatíveis!",
          this.$config.dados.errorColor
        );
        this.$usuario.user.error.senha2 = "As senhas são incompatíveis!";
        return;
      }
      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_SENHA_CONSUMIDOR + idusuario,
          JSON.stringify({
            senha_antiga: this.user.old_password,
            senha_nova: this.user.senha,
          })
        )
        .then(response => {
          if (response) {
            localStorage.removeItem("token");
            this.$axios.destroy(true);
            this.user.old_password = "";
            this.user.show_old_pass = "password";
            this.user.senha = "";
            this.user.show_senha = "password";
            this.user.senha2 = "";
            this.user.show_senha2 = "password";
            if (location.pathname != "login") {
              setTimeout(() => {
                router.push("/");
              }, 3000);
            }
          }
        });
    },

    filtroConsumidores() {
      this.filtros = [];
      function formatDate(date) {
        const dateParts = date.split("/");
        const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        return formattedDate;
      }

      if (this.filter.nome !== "") {
        this.filtros.push({
          campo: "nome",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.nome,
        });
      }

      if (this.filter.razao_social !== "") {
        this.filtros.push({
          campo: "razao_social",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.razao_social,
        });
      }

      if (this.filter.documento !== "") {
        this.filtros.push({
          campo: "documento",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.documento,
        });
      }

      // if(this.filter.cnpj !== '') {
      //     this.filtros.push({
      //         campo: 'cnpj',
      //         tipo: 'string',
      //         orientacao: 'like',
      //         valor: this.filter.cnpj
      //     })
      // }

      if (this.filter.passaporte !== "") {
        this.filtros.push({
          campo: "passaporte",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.passaporte,
        });
      }

      if (this.filter.status != "" && this.filter.status != null) {
        this.filtros.push({
          campo: "status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      if (this.filter.dataInicio != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "maior",
          valor: formatDate(this.filter.dataInicio) + " 00:00",
        });
      }

      if (this.filter.dataFim != "") {
        this.filtros.push({
          campo: "ins_dthr",
          tipo: "date",
          orientacao: "menor",
          valor: formatDate(this.filter.dataFim) + " 23:59",
        });
      }

      if (this.filter.tipoPessoa != "" && this.filter.tipoPessoa != null) {
        this.filtros.push({
          campo: "tipo_pessoa",
          tipo: "string",
          valor: this.filter.tipoPessoa,
        });
      }

      let filtered = this.filtros;
      this.cadastro.loading_consumidores = true;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_CONSUMIDORES_MARKET,
          JSON.stringify({
            filtros: filtered,
          })
        )
        .then(response => {
          this.cadastro.loading_consumidores = false;
          this.consumidores = response;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    imprimirIngresso(iditem, sequenciador) {
      let dados = {
        loja: sequenciador,
        idioma: "pt",
        iditem: iditem,
        is_download: true,
      };

      this.$axios
        .postPDF(this.ENDPOINTS.IMPRIMIR_INGRESSO, dados)
        .then(response => {
          var file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    // ---- FUNÇÃO QUE VALIDA O CADASTRO ---- //
    async validarCadastro(type) {
      // if(this.cadastro.dados_cadastrais.pessoa === 'FISICA') {
      if (this.cadastro.dados_cadastrais.pais === "") {
        this.$config.alert("Selecione o pais!", this.$config.dados.errorColor);
        this.cadastro.dados_cadastrais.error.pais = "Selecione o pais!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.nome.length < 2 ||
        this.cadastro.dados_cadastrais.nome === ""
      ) {
        this.$config.alert(
          "Preencha o nome corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.nome =
          "Preencha o nome corretamente!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.dt_nascimento.length < 2 ||
        this.cadastro.dados_cadastrais.dt_nascimento === ""
      ) {
        this.$config.alert(
          "Preencha a data de nascimento corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.dt_nascimento =
          "Preencha a data de nascimento corretamente!";
        return;
      }

      if (this.cadastro.dados_cadastrais.pais === "Brasil") {
        if (
          (this.cadastro.dados_cadastrais.documento &&
            this.cadastro.dados_cadastrais.documento.length < 13) ||
          this.cadastro.dados_cadastrais.documento === ""
        ) {
          this.$config.alert(
            "Preencha o documento corretamente!",
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.documento =
            "Preencha o documento corretamente!";
          return;
        }
      } else {
        if (
          (this.cadastro.dados_cadastrais.passaporte &&
            this.cadastro.dados_cadastrais.passaporte.length < 8) ||
          this.cadastro.dados_cadastrais.passaporte === ""
        ) {
          this.$config.alert(
            "Preencha o passaporte corretamente!",
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.passaporte =
            "Preencha o passaporte corretamente!";
          return;
        }
      }

      // }

      // if(this.cadastro.dados_cadastrais.pessoa === 'JURIDICA') {
      //     if(this.cadastro.dados_cadastrais.cnpj && this.cadastro.dados_cadastrais.cnpj.length < 17 || this.cadastro.dados_cadastrais.cnpj === '')
      //         { this.$config.alert('Preencha o CNPJ corretamente!', this.$config.dados.errorColor); this.cadastro.dados_cadastrais.error.cnpj = 'Preencha o CNPJ corretamente!'; return }

      //     if(!this.$config.validarCNPJ(this.cadastro.dados_cadastrais.cnpj))
      //         { this.$config.alert('CNPJ inválido!', this.$config.dados.errorColor); this.cadastro.dados_cadastrais.error.cnpj = 'CNPJ inválido!'; return }

      //     if(this.cadastro.dados_cadastrais.razao_social && this.cadastro.dados_cadastrais.razao_social.length < 5 || this.cadastro.dados_cadastrais.razao_social === '')
      //         { this.$config.alert('Preencha a razão social corretamente!', this.$config.dados.errorColor); this.cadastro.dados_cadastrais.error.razao_social = 'Preencha a razão social corretamente!'; return }
      // }

      if (
        (this.cadastro.dados_cadastrais.email &&
          this.cadastro.dados_cadastrais.email.length < 5) ||
        this.cadastro.dados_cadastrais.email === ""
      ) {
        this.$config.alert(
          "Preencha o e-mail corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.email =
          "Preencha o e-mail corretamente!";
        return;
      }

      if (!this.$config.validarEmail(this.cadastro.dados_cadastrais.email)) {
        this.$config.alert("E-mail inválido!", this.$config.dados.errorColor);
        this.cadastro.dados_cadastrais.error.email = "E-mail inválido!";
        return;
      }

      if (
        (this.cadastro.dados_cadastrais.celular &&
          this.cadastro.dados_cadastrais.celular.length < 10) ||
        this.cadastro.dados_cadastrais.celular === ""
      ) {
        this.$config.alert(
          "Preencha o Nº de celular corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.celular =
          "Preencha o Nº de celular corretamente!";
        return;
      }

      if (this.cadastro.dados_cadastrais.status === "") {
        this.$config.alert(
          "Selecione o status!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.status = "Selecione o status!";
        return;
      }

      if (
        this.cadastro.dados_cadastrais.cep.length < 8 ||
        this.cadastro.dados_cadastrais.cep === ""
      ) {
        this.$config.alert(
          "Insira o CEP corretamente!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.cep = "Insira o CEP corretamente!";
        return;
      }

      if (this.cadastro.dados_cadastrais.estado === "") {
        this.$config.alert(
          "Selecione o estado!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.estado = "Selecione o estado!";
        return;
      }

      if (this.cadastro.dados_cadastrais.cidade === "") {
        this.$config.alert(
          "Selecione a cidade!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.cidade = "Selecione a cidade!";
        return;
      }

      if (this.cadastro.dados_cadastrais.bairro === "") {
        this.$config.alert("Insira o bairro!", this.$config.dados.errorColor);
        this.cadastro.dados_cadastrais.error.bairro = "Insira o bairro!";
        return;
      }

      if (this.cadastro.dados_cadastrais.logradouro === "") {
        this.$config.alert(
          "Insira o logradouro!",
          this.$config.dados.errorColor
        );
        this.cadastro.dados_cadastrais.error.logradouro =
          "Insira o logradouro!";
        return;
      }

      if (this.cadastro.dados_cadastrais.end_numero === "") {
        this.$config.alert("Insira o número!", this.$config.dados.errorColor);
        this.cadastro.dados_cadastrais.error.end_numero = "Insira o número!";
        return;
      }

      if (type === "editar") {
        this.alterarConsumidor();
      } else {
        this.cadastrarConsumidor();
      }
    },

    limpaFormularioDeConsumidor() {
      this.cadastro.dados_cadastrais.pessoa = "JURIDICA";
      this.cadastro.dados_cadastrais.nome = "";
      this.cadastro.dados_cadastrais.dt_nascimento = "";
      this.cadastro.dados_cadastrais.documento = "";
      this.cadastro.dados_cadastrais.email = "";
      this.cadastro.dados_cadastrais.celular = "";
      this.cadastro.dados_cadastrais.idioma = "";
      this.cadastro.dados_cadastrais.status = "";
      this.cadastro.dados_cadastrais.foto.imagem = null;
      this.cadastro.dados_cadastrais.foto.have = false;
      delete this.cadastro.dados_cadastrais.foto.object;
      this.cadastro.dados_cadastrais.error.nome = [];
      this.cadastro.dados_cadastrais.error.email = [];
      this.cadastro.dados_cadastrais.error.celular = [];
      this.cadastro.dados_cadastrais.error.status = [];
      this.cadastro.dados_cadastrais.error.dt_nascimento = [];
      this.cadastro.dados_cadastrais.error.documento = [];

      this.cadastro.dados_cadastrais.bairro = "";
      this.cadastro.dados_cadastrais.logradouro = "";
      this.cadastro.dados_cadastrais.end_numero = "";
      this.cadastro.dados_cadastrais.cep = "";
      this.cadastro.dados_cadastrais.pais = "";
      this.cadastro.dados_cadastrais.estado = "";
      this.cadastro.dados_cadastrais.cidade = "";
      this.cadastro.dados_cadastrais.error.bairro = [];
      this.cadastro.dados_cadastrais.error.logradouro = [];
      this.cadastro.dados_cadastrais.error.end_numero = [];
      this.cadastro.dados_cadastrais.error.cep = [];
      this.cadastro.dados_cadastrais.error.pais = [];
      this.cadastro.dados_cadastrais.error.estado = [];
      this.cadastro.dados_cadastrais.error.cidade = [];

      this.cadastro.dados_cadastrais.cnpj = "";
      this.cadastro.dados_cadastrais.razao_social = "";
      this.cadastro.dados_cadastrais.error.cnpj = [];
      this.cadastro.dados_cadastrais.error.razao_social = [];
    },

    limpaFiltros() {
      this.filter.nome = "";
      this.filter.razao_social = "";
      this.filter.documento = "";
      this.filter.cnpj = "";
      this.filter.status = "";
      this.filter.tipoPessoa = "";
      this.filter.dataInicio = "";
      this.filter.dataFim = "";
      this.filtros = [];
    },
  },
});
